const menuItems = {
  items: [
    {
      id: 'home',
      title: 'Home',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-home',
          url: '/dashboard',
        },
        {
          id: 'map',
          title: 'Mappa visite',
          type: 'item',
          icon: 'feather icon-map',
          url: '/map',
          caps: { some: ['show_map'] },
        },
        {
          id: 'map_dealers',
          title: 'Mappa dealer',
          type: 'item',
          icon: 'feather icon-map',
          url: '/map_dealers',
          caps: { some: ['show_map'] },
        },
        {
          id: 'messages',
          title: 'Bacheca',
          type: 'item',
          icon: 'fas fa-envelope-open-text',
          url: '/messages',
          caps: { some: ['show_messages', 'manage_messages'] },
        },
        {
          id: 'documents',
          title: 'Documenti',
          type: 'item',
          icon: 'feather icon-folder',
          url: '/documents',
          caps: { some: ['show_documents', 'manage_documents'] },
        },
      ],
    },
    {
      id: 'visits_group',
      title: 'Visite',
      type: 'group',
      icon: 'icon-ui',
      caps: {
        some: [
          'show_appointments',
          'manage_appointments',
          'show_calendar',
          'manage_calendar',
          'show_contracts',
          'manage_contracts',
          'show_metadata',
          'manage_metadata',
        ],
      },
      children: [
        {
          id: 'visits',
          title: 'Visite',
          type: 'item',
          icon: 'feather icon-clipboard',
          url: '/appointments',
          caps: { some: ['show_appointments', 'manage_appointments'] },
        },
        {
          id: 'calendar',
          title: 'Calendario',
          type: 'item',
          icon: 'feather icon-calendar',
          url: '/calendar',
          caps: { some: ['show_calendar', 'manage_calendar'] },
        },
        {
          id: 'contracts',
          title: 'Pratiche contrattuali',
          type: 'item',
          icon: 'fas fa-file-contract',
          url: '/contracts',
          caps: { some: ['show_contracts', 'manage_contracts'] },
        },
        {
          id: 'metadata',
          title: 'Metadati',
          type: 'item',
          icon: 'fas fa-image',
          url: '/metadata',
          caps: { some: ['show_metadata', 'manage_metadata'] },
        },
      ],
    },
    {
      id: 'management',
      title: 'Gestione',
      type: 'group',
      icon: 'icon-ui',
      caps: {
        some: ['show_users', 'manage_users', 'show_brands', 'manage_brands', 'show_categories', 'manage_categories'],
      },
      children: [
        {
          id: 'manage_users',
          title: 'Utenti',
          type: 'item',
          icon: 'feather icon-user',
          url: '/users',
          caps: { some: ['show_users', 'manage_users'] },
        },
        {
          id: 'manage_brands',
          title: 'Brand',
          type: 'item',
          icon: 'fa fa-handshake',
          url: '/brands',
          caps: { some: ['show_brands', 'manage_brands'] },
        },
        {
          id: 'manage_dealers',
          title: 'Dealer',
          type: 'item',
          icon: 'fa fa-store',
          url: '/dealers',
          caps: { some: ['show_dealers', 'manage_dealers'] },
        },
        {
          id: 'manage_categories',
          title: 'Categorie',
          type: 'item',
          icon: 'fa fa-box',
          url: '/categories',
          caps: { some: ['show_categories', 'manage_categories'] },
        },
      ],
    },
  ],
}

export default menuItems
